import { IconProps, NocIconGenerator } from '../common';

export const ExportCircle = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ExportCircle',
            path: (
                <>
                    <path
                        d="M9.31982 6.50043L11.8798 3.94043L14.4398 6.50043"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11.8799 14.1798V4.00977"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4 12C4 16.42 7 20 12 20C17 20 20 16.42 20 12"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
